import React from 'react';
// styles
import styled, { css } from 'styled-components';
import { gridSizes, weights } from 'utils/style';

const h1RegularCSS = css`
  font-size: 32px;
  font-weight: ${weights('medium')};
  line-height: 40px;
  color: var(--primary500);

  margin: 0;
  margin-top: ${gridSizes('XL')};
`;
const StyledH1 = styled.h1`
  ${h1RegularCSS}
`;

const h2RegularCSS = css`
  color: var(--grey900);
  font-size: 20px;
  font-weight: ${weights('medium')};
  line-height: ${gridSizes('L')};
  margin: ${gridSizes('M')} 0 ${gridSizes('S')};
  ${({ variant }) =>
    variant === 'subtitle' &&
    css`
      color: var(--grey700);
      font-size: ${gridSizes('M')};
      margin: 0;
      margin-top: ${gridSizes('M')};
      font-weight: ${weights('regular')};
      line-height: 19px;
    `}
`;
const StyledH2 = styled.h2`
  ${h2RegularCSS}
`;

const h3RegularCSS = css`
  margin: 0;
  padding: 0;
  font-size: 2.4rem;
  font-weight: 500;
`;
const StyledH3 = styled.h3`
  ${h3RegularCSS}
`;

const Title = ({ children, level, variant }) => {
  if (level === 'h2') {
    return <StyledH2 variant={variant}>{children}</StyledH2>;
  }
  if (level === 'h3') {
    return <StyledH3 variant={variant}>{children}</StyledH3>;
  } else {
    return <StyledH1 variant={variant}> {children} </StyledH1>;
  }
};

export default React.memo(Title);
